import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const GetAllPlayers = (keyword, isActive, skipCount, maxResultCount, sorting) => {
  const url = apiConstants.GetAll;
  const keywordString = keyword !== null ? `Keyword=${keyword}&` : '';
  return httpClient.get(`${url}?${keywordString}IsActive=${isActive}&SkipCount=${skipCount}&MaxResultCount=${maxResultCount}`).then(result => result.data.result);
};

const GetPlayer = (id) => {
  const url = `${apiConstants.Get}?Id=${id}`;

  return httpClient.get(url).then(result => result.data.result);
};


// Mess...
const MapType = (type) => {
  if (type === 'SevenDayMember' || type === 0) {
    return 'Seven day member';
  }
  if (type === 'FiveDayMember' || type === 1) {
    return 'Five day member';
  }
  if (type === 'FlexibleMember' || type === 2) {
    return 'Flexible member';
  }
  if (type === 'GuestOfMember' || type === 3) {
    return 'Guest of member';
  }
  if (type === 'Visitor' || type === 4) {
    return 'Visitor';
  }
  if (type === 'MemberOfSociety' || type === 5) {
    return 'Member of society';
  } if (type === 'System' || type === 6) {
    return 'System';
  }
};

const GetTypeChar = (type) => {
  if (type === 'SevenDayMember' || type === 'Seven day member' || type === 0) {
    return '7';
  }
  if (type === 'FiveDayMember' || type === 'Five day member' || type === 1) {
    return '5';
  }
  if (type === 'FlexibleMember' || type === 'Flexible member' || type === 2) {
    return 'F';
  }
  if (type === 'GuestOfMember' || type === 'Guest of member' || type === 3) {
    return 'G';
  }
  if (type === 'Visitor' || type === 4) {
    return 'V';
  }
  if (type === 'MemberOfSociety' || type === 'Member of society' || type === 5) {
    return 'S';
  } if (type === 'System') {
    return 'S';
  }
};

const GetTypeBackground = (type) => {
  if (type === 'SevenDayMember' || type === 'Seven day member' || type === 0) {
    return 'from-green-500 to-green-700';
  }
  if (type === 'FiveDayMember' || type === 'Five day member' || type === 1) {
    return 'from-green-500 to-green-700';
  }
  if (type === 'FlexibleMember' || type === 'Flexible member' || type === 2) {
    return 'from-blue-500 to-blue-700';
  }
  if (type === 'GuestOfMember' || type === 'Guest of member' || type === 3) {
    return 'from-red-500 to-red-700';
  }
  if (type === 'Visitor' || type === 4) {
    return 'from-red-500 to-red-700';
  }
  if (type === 'MemberOfSociety' || type === 'Member of society' || type === 5) {
    return 'from-red-500 to-red-700';
  }
  if (type === 'System' || type === 6) {
    return 'from-gray-700 to-gray-900';
  }
};

export {
  GetAllPlayers, MapType, GetTypeChar, GetTypeBackground, GetPlayer,
};
